import Chip from "@mui/material/Chip"

import { REPORT_STATUS } from "./activityReportRowUtils"

const STATUS_PROPS = {
  [REPORT_STATUS.pending]: { label: "Pending", color: "warning" },
  [REPORT_STATUS.sent]: { label: "Sent", color: "success" },
  [REPORT_STATUS.failed]: { label: "Failed", color: "error" },
}

export default function ActivityReportStatusChip({ status }) {
  const props = STATUS_PROPS[status] || {
    label: status || "—",
    color: "default",
  }
  return (
    <Chip
      size="small"
      label={props.label}
      color={props.color}
      variant="outlined"
    />
  )
}
